import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type ICianApiSiteV1GetUserDataByRequestResponse,
  fetchCianApiSiteV1GetUserDataByRequest,
} from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

import { prepareUser } from '../mappers/prepareUser';
import { type IApplicationContext } from '../types/applicationContext';
import { type TUser } from '../types/user';

interface IFetchUserParameters {
  subdomain: string;
}

export const fetchUser = withTypeSafeApiResult<{}, ICianApiSiteV1GetUserDataByRequestResponse>(
  fetchCianApiSiteV1GetUserDataByRequest,
);

const DEFAULT_USER: TUser = { isAuthenticated: false };

export async function fetchUserSafe(context: IApplicationContext, { subdomain }: IFetchUserParameters): Promise<TUser> {
  const userData = await fetchUser(context, {}, { subdomain });
  if (userData.isErr()) {
    context.logger.warning(userData.Err, { degradation: 'Информация о пользователе' });
  }

  return userData.map(prepareUser).unwrapOr(DEFAULT_USER);
}
